export default __webpack_public_path__ + "028562c5713f7ab9001e85837e89d97a.png";